// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__6BXed","inputWrap":"styles_inputWrap__1ZxEs","input":"styles_input__1z0bV"};